"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceCreateSibling = void 0;
const create_sibling_workspace_1 = require("@app/ac/create-sibling-workspace");
const forms_1 = require("@app/component/ui/forms");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
require("./workspace-create-sibling.scss");
// the backend's `workspaces.create` validator allows 2-100 characters
const MIN_NAME_LENGTH = 2;
const MAX_NAME_LENGTH = 100;
const WorkspaceCreateSibling = ({ close, }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const { control, handleSubmit, setError, formState: { isSubmitting }, } = (0, react_hook_form_1.useForm)({ defaultValues: { name: '' } });
    const onSubmit = handleSubmit(async ({ name }) => {
        const result = await dispatch((0, create_sibling_workspace_1.createSiblingWorkspace)({ name: name.trim() }));
        if (result === create_sibling_workspace_1.CREATE_SIBLING_WORKSPACE_RESULT.NAME_EXISTS) {
            setError('name', { message: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('WS_NAME_ALREADY_EXISTS')) });
            return;
        }
        if (result === create_sibling_workspace_1.CREATE_SIBLING_WORKSPACE_RESULT.CREATED) {
            close?.();
        }
    });
    return (react_1.default.createElement(_ui_1.Modal, { size: _ui_1.Modal.SIZES.S, headerContent: react_1.default.createElement(_ui_1.Text, { text: (0, util_1.t)('ORG_SP_WORKSPACES_WORKSPACE_ADD_NEW'), type: _ui_1.Text.TYPES.BODY_LARGE, weight: _ui_1.Text.WEIGHTS.BOLD }), footerContent: react_1.default.createElement(_ui_1.Flex, { stretch: true },
            react_1.default.createElement(_ui_1.Button, { onClick: close, label: (0, util_1.t)('CLOSE'), size: _ui_1.Button.SIZES.FULL }),
            react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_6, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
            react_1.default.createElement(_ui_1.Button, { size: _ui_1.Button.SIZES.FULL, style: _ui_1.Button.STYLES.CONTAINED, label: (0, util_1.t)('ADD'), disabled: isSubmitting, loading: isSubmitting, onClick: onSubmit, testid: 'workspace-create-sibling-submit' })) },
        react_1.default.createElement("div", { className: 'ds-workspace-create-sibling' },
            react_1.default.createElement(forms_1.TextInput, { control: control, name: 'name', label: (0, util_1.t)('ORG_SP_WORKSPACES_WORKSPACE_NAME_LABEL'), placeholder: (0, util_1.t)('ORG_SP_WORKSPACES_WORKSPACE_NAME_PLACEHOLDER'), maxLength: MAX_NAME_LENGTH, testid: 'workspace-create-sibling-name', rules: {
                    validate: (value) => value.trim().length >= MIN_NAME_LENGTH ||
                        (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('FORM_ERR_MISSING_REQUIRED')),
                } }))));
};
exports.WorkspaceCreateSibling = WorkspaceCreateSibling;
exports.default = exports.WorkspaceCreateSibling;
